import SmartLink from "../../components/shared/smart-link"

export default SmartLink
